// @flow

import React from 'react'
import logo from '../../../assets/img/YA_logo.svg'
import searchIcon from '../../../assets/img/Haku.svg'
import css from './Header.css'
import Search from './Search'
import {Link} from 'react-router-dom'

type Props = {
  searchPlaceholder: string,
  showSearch: boolean,
  onSearch: Function,
  keyword: ?string,
  onKeywordChange: Function
}

const Header = ({searchPlaceholder, showSearch, onSearch, keyword, onKeywordChange}: Props) => {
  return (
    <header className={css.component}>
      <div className={css.wrapper}>
        <Link to="/">
          <img className={css.logo} src={logo} alt="Yliopiston apteekin logo" />
        </Link>
        {showSearch && (
          <div className={css.searchBar}>
            <Search
              placeholderText={searchPlaceholder}
              keyword={keyword}
              onChange={value => onKeywordChange(value)}
              onSearch={(keyword) => onSearch(keyword)}
              sizeL={false}
            />
          </div>
        )}
        {showSearch && (
          <div className={css.searchButton}>
            <Link to="/">
              <img className={css.searchIcon} src={searchIcon} alt="Search" />
            </Link>
          </div>
        )}
      </div>
    </header>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/common/components/Header.js